<sh-page-header [title]="title" [contextItems]="contextItems" [primaryNavigationItems]="primaryNav$ | async" [secondaryNavigationItems]="secondaryNav$ | async">
</sh-page-header>

@for (rejection of rejections; track rejection) {
  <digihaven-rejection-notification [rejection]="rejection" [rejectionTranslations]="rejectionTranslations">
  </digihaven-rejection-notification>
}

@if (notification) {
  <sh-notification
    [type]="notification?.type"
    [title]="notification?.title | translate"
    [message]="notification?.message | translate"
    [messageList]="notification?.messageList"
    [icon]="notification?.icon"
    class="digihaven-header-notification"
  ></sh-notification>
}

@if (warningNotification) {
  <sh-notification
    [type]="warningNotification?.type"
    [title]="warningNotification?.title | translate"
    [message]="warningNotification?.message | translate"
    [messageList]="warningNotification?.messageList"
    [icon]="warningNotification?.icon"
  ></sh-notification>
}

@if (tabItemsInternal$ | async) {
  <nav class="sh-tab-navigation">
    @for (tabItem of tabItemsInternal$ | async; track tabItem) {
      <ng-container
        *ngTemplateOutlet="shouldEnableNavigationItem(tabItem.route) ? enabledNavigationItem : disabledNavigationItem; context: { tabItem: tabItem }"
      ></ng-container>
    }
  </nav>
}

<ng-template #enabledNavigationItem let-tabItem="tabItem">
  <a
    #rla="routerLinkActive"
    [shNavigationLink]="tabItem"
    class="sh-tab-navigation__item"
    routerLinkActive="-sh-is-active"
    [attr.aria-current]="rla.isActive ? 'location' : null"
    >
    {{ tabItem.label }}
  </a>
</ng-template>

<ng-template #disabledNavigationItem let-tabItem="tabItem">
  <span class="sh-tab-navigation__item--disabled">{{ tabItem.label }}</span>
</ng-template>
